import React, { useEffect, useMemo, useRef, useState } from "react";
import largeBorder from "./Assets/largeBorder.png";

function LandingpageTray({ children, className, borderColor = "#c99b1276" }) {
  // Responsive breakpoints derived from viewport
  const getViewport = () => {
    if (typeof window === 'undefined') return { isMobile: false, isTablet: false };
    const w = window.innerWidth;
    return { isMobile: w < 768, isTablet: w >= 768 && w < 1200 };
  };

  const [viewport, setViewport] = useState(getViewport());
  const rafId = useRef(0);

  useEffect(() => {
    const onResize = () => {
      if (rafId.current) cancelAnimationFrame(rafId.current);
      rafId.current = requestAnimationFrame(() => setViewport(getViewport()));
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      if (rafId.current) cancelAnimationFrame(rafId.current);
    };
  }, []);

  const { isMobile, isTablet } = viewport;

  // Outer wrapper mirrors requested z-index/overflow and spacing
  const wrapperStyle = useMemo(() => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'auto',
    position: 'relative',
    zIndex: 20, // keep above any layout overlays
    overflow: 'visible', // allow content to be fully visible on mobile
    marginTop: 0,
    marginBottom: 0,
  }), []);

  // Percentage widths and insets tuned per breakpoint
  const outerWidth = useMemo(() => '95%', []);
  const innerWidthPct = useMemo(() => (isMobile ? 92 : 93), [isMobile]);
  const inset = useMemo(() => (isMobile ? '8% 6% 8% 6%' : (isTablet ? '7% 5% 7% 5%' : '6% 4% 6% 4%')), [isMobile, isTablet]);

  // Inner padding similar to provided responsive spacing
  const paddingInline = isMobile ? 16 : 24;
  const paddingBlock = isMobile ? 28 : 40;

  // Frame div uses two background layers (inner above outer) so the frame can stretch with content height
  const frameStyle = useMemo(() => ({
    position: 'relative',
    width: '100%',
    maxWidth: 2000,
    boxSizing: 'border-box',
    background: `
          linear-gradient(180deg, #171326 0%, rgba(23, 19, 38, 0.98) 42%, #171326 100%),
          radial-gradient(70% 120% at 50% 0%, rgba(114, 82, 181, 0.18) 0%, rgba(23, 19, 38, 0) 60%)
        `,

    padding: `${paddingBlock}px ${paddingInline}px`,
  }), [paddingBlock, paddingInline]);

  // Common mask style for border layers (uses the imported PNG as a mask)
  const maskBase = useMemo(() => ({
    WebkitMaskImage: `url(${largeBorder})`,
    maskImage: `url(${largeBorder})`,
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center center',
    maskPosition: 'center center',
  }), []);

  return (
    <div className={className} style={wrapperStyle}>
      <div style={frameStyle}>
        {/* Outer border layer */}
        {/* <div
          aria-hidden
          style={{
            ...maskBase,
            position: 'absolute',
            inset: 0,
            zIndex: 0,
            pointerEvents: 'none',
            backgroundColor: borderColor,
            WebkitMaskSize: `${outerWidth} 100%`,
            maskSize: `${outerWidth} 100%`,
            
          }}
        /> */}
        {/* Inner border layer */}
        {/* <div
          aria-hidden
          style={{
            ...maskBase,
            position: 'absolute',
            inset: 0,
            zIndex: 0,
            pointerEvents: 'none',
            backgroundColor: borderColor,
            WebkitMaskSize: `${innerWidthPct}% 100%`,
            maskSize: `${innerWidthPct}% 100%`,
          }}
        /> */}
        {/* Content */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default React.memo(LandingpageTray);
